<script setup lang="ts">
const props = defineProps<{
  headerThemeKeys: Record<string, string>;
  footerThemeKeys: Record<string, string>;
  links: Record<string, string>;
}>();
</script>

<template>
  <ContentHeader
    :themeKeys="props.headerThemeKeys"
    :links="props.links"
  />
  <slot />
  <ContentFooter
    :themeKeys="props.footerThemeKeys"
    :links="props.links"
  />
</template>

<style>
@import '../../assets/css/main.css';

.outer-container {
  @apply mx-4 my-4 md:mx-8 md:my-8 xl:mx-32 xl:my-24;
}

.outer-p-container {
  @apply px-4 py-4 md:px-8 md:py-8 xl:px-32 xl:py-24;
}

.inner-container {
  @apply max-w-6xl mx-auto;
}
</style>
